import {EVENT_ARB_TYPES_CODES, SCANNER_PAGES_NAMES, SCANNER_TYPES_NAMES} from '../const';
import {i18n} from '../startup/i18n';
import {getPropsByName} from '../startup/helpers';

export default {
  formDataToProSearchRequest(state, getters, globalState) {
    function checkAdditionalData() {
      // Для пользователя с полным доступом нужно подождать дополнительные данные с сервера
      if (state.settings.access_token) {
        return state.userBookmakers; // Ждем список букмеккеров
      }
      return true;
    }

    function fillFormData() {
      const {
        auto_update,
        notification_sound,
        notification_popup,
        show_event_arbs,
        grouped,
        per_page,
        sort_by,
        event_id,
        koef_format,
      } = state.scannerPage.selectedSettings; // Добавим только нужные поля из selectedSettings

      const defaultParams = {
        auto_update,
        notification_sound,
        notification_popup,
        show_event_arbs,
        grouped,
        per_page,
        sort_by,
        koef_format,
        'mode': document.getElementById('mode').value,
        'event_id': event_id || '',
        'q': state.headerSearchQuery,
        'event_arb_types': getEventList(),
        'search_filter': getFiltersIds(),
        'is_live': state.scannerPageType === SCANNER_TYPES_NAMES.live,
      };

      if (state.settings.access_token) {
        // Если у пользователя есть доступ, то включим в тело запроса массив айдишников активных букмекеров
        defaultParams.bk_ids = getActiveBookmakersIdsList();
      }

      if (state.userBookmakers) {
        const bkKoefsStr = getBookmakersKoefs();
        bkKoefsStr ? defaultParams.bookmaker_koefs = bkKoefsStr : null;
      }

      if (!getters.getUserPaidStatus && state.defaultFilterRequestParams) {
        // Если у пользователя нету доступа и он в пределах сессии менял дефолтный фильтр,
        // то добавим его изменения в параметры запроса
        Object.assign(defaultParams, getters.getDefaultFilterRequestParams);
      }

      return defaultParams;
    }

    function getEventList() {
      const eventsList = [];
      const {selectedSettings} = state.scannerPage;

      Object.keys(selectedSettings).forEach((prop) => {
        Object.hasOwnProperty.call(EVENT_ARB_TYPES_CODES, prop) && // Если в списке евентов есть свойство с таким именем
        !!selectedSettings[prop] ? // И с сервера пришло, что это свойство true
          eventsList.push(EVENT_ARB_TYPES_CODES[prop]) : // То заполним массив евентов
          null;
      });
      return eventsList;
    }

    function getFiltersIds() {
      const activeFilters = state.scannerPage.filtersList.filter((item) => {
        return item.active;
      });

      return getPropsByName(activeFilters, 'id');
    }

    function getActiveBookmakersIdsList() {
      return getPropsByName(getters.activeUserBookmakers, 'bookmaker_id');
    }

    function getBookmakersKoefs() {
      return getters.activeUserBookmakers
          .filter((bk)=>{ // В поле bookmaker_koefs отправляется строка которая формируется с полей min_odds, max_odds, min_sum. Если хотя бы одно из этих полей пришло с сервера, то формируем строку
            return bk.min_odds != null || // задается в настройках букмекеров в личном кабинете
            bk.max_odds != null || // задается в настройках букмекеров в личном кабинете
            bk.market_deep != null; // market_deep задается для бирж(exchanges) в личном кабинете
          })
          .map((bk)=>{
            return `${+bk.bookmaker_id}-${bk.min_odds || 0}-${bk.max_odds || 0}-${bk.market_deep || 0}`; // Получаем строку формата 21-1-5-0 21-0-0-1 и тд
          }).join(',');
    }

    return globalState.directories &&
      state.settings &&
      checkAdditionalData() &&
      state.scannerPage.searchSettings &&
      state.scannerPage.filtersList &&
      fillFormData();
  },
  getDefaultFilterRequestParams(state) {
    // Если у пользователя нету доступа и поменял дефолтный фильтр, то на его основании сделаем данные для запроса с его учетом
    const defaultFilterParams = {};
    Object.entries(state.defaultFilterRequestParams)
        .forEach(([key, val])=>{
          // Преобразуем объект, чтобы поля фильтра имели нужный формат для сервера
          defaultFilterParams[`default_filter[${key}]`] = val;
        });
    return defaultFilterParams;
  },
  authDataToRequest: (state) => (isRest = false) => {
    const baseUrl = isRest ?
      state.settings.domains.rest[state.scannerPageType] :
      state.settings.domains[state.scannerPageType];

    return {
      baseUrl,
      locale: i18n.global.locale,
      accessToken: state.settings.access_token,
    };
  },
  getUserPaidStatus(state) {
    return isPaidPlan(
        state.scannerPageType,
        state.scannerPageName,
        state.scannerPage.apiPageName,
    );
    function isPaidPlan(type, scannerPageName, apiPageName) {
      // apiPageName - bot_arbs || bot_valuebets
      // scannerPageName - arbs || valuebets
      const pageName = apiPageName || scannerPageName; // В приоритете наименование страниц апи
      // live_arbs_paid и тому подобное приходят строкой -> "true" или "false"
      const paidFlag = state.userData && state.userData[type + '_' + pageName + '_paid'];
      return (paidFlag === 'true' || paidFlag === true) && !state.userData.frozen_status;
    }
  },
  getAdminBookmakerEventsLink(state) {
    const adminUrl = state.userData?.scanner_admin_urls?.[state.scannerPageType];
    const outcomes = state.scannerPage.dataToScannerCalculator;
    if (!adminUrl || !outcomes) return null;

    const ids = new Set(outcomes.map(({selectedBet}) => atob(selectedBet.id).replace(/\|.*/, '')));
    return `${adminUrl}/bookmaker_events?bookmaker_event_id=${[...ids].join(',')}`;
  },
  getAdminEventBetLink: (state) => (bet) => {
    const adminUrl = state.userData?.scanner_admin_urls?.[state.scannerPageType];
    if (!adminUrl) return null;

    return `${adminUrl}/event_bets?bookmaker_event_id=${atob(bet.id).replace(/\|.*/, '')}&bet_id=${bet.id}`;
  },
  activeUserBookmakers(state) {
    return state.userBookmakers ?
      state.userBookmakers.bookmakers
          .filter((item) => {
            return item.active;
          }) :
      null;
  },
  getCoefficientFormat(state) {
    return state.scannerPage.selectedSettings.koef_format || this.defaultCoefficientFormat();
  },
  getPercentValue(state) {
    return state.percentValue;
  },
  /**
   * Retrieves the default coefficient format based on the user's country code.
   * If the country code is unavailable or not mapped, it defaults to 'decimal'.
   *
   * @returns {string} The coefficient format (e.g., 'decimal', 'fractional', etc.).
   */
  defaultCoefficientFormat() {
    return window.ip_data && window.koef_format_by_country_code.get(window.ip_data.country_code.toLowerCase()) || 'decimal';
  },
};
